import { render } from "./RecursiveMenuItem.vue?vue&type=template&id=4d43975f"
import script from "./RecursiveMenuItem.vue?vue&type=script&lang=js"
export * from "./RecursiveMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__